<div class="viewer-header">
  <h2>{{ data.tituloDoArquivo }}</h2>
  <div>
    <button mat-icon-button (click)="toggleFullscreen()" [matTooltip]="isFullscreen ? 'Sair da tela cheia' : 'Visualizar em tela cheia'">
      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close matTooltip="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="viewer-content">
  <ngx-extended-pdf-viewer
    *ngIf="isPdf && pdfReady"
    [src]="pdfSrc!"
    [showToolbar]="true"
    [showDownloadButton]="false"
    [showPrintButton]="false"
    [showOpenFileButton]="false"
    [showPropertiesButton]="false"
    [showSecondaryToolbarButton]="false"
    [showSidebarButton]="false"
    [showRotateButton]="false"
    [showDrawEditor]="false"
    [showTextEditor]="false"
    [showStampEditor]="false"
    [showHighlightEditor]="false"
    [showBorders]="false"
    [theme]="'dark'"
    [textLayer]="true"
    height="100%"
  ></ngx-extended-pdf-viewer>
  <img *ngIf="isImage" [src]="mediaSrc" class="viewer-media" />
  <video *ngIf="isVideo" controls class="viewer-media">
    <source [src]="mediaSrc" type="video/mp4" />
  </video>
</div>
